// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq2 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dItemList.eqItemList.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const categoryIsSymbol = {reflectSymbol: () => "category"};
const idsIsSymbol = {reflectSymbol: () => "ids"};
const listIsSymbol = {reflectSymbol: () => "list"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const priceIsSymbol = {reflectSymbol: () => "price"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const ItemIsSymbol = {reflectSymbol: () => "Item"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const Item = x => x;
const toFillFormTypeItem = {fillFormDataType: v => "unknown"};
const newtypeItem_ = {Coercible0: () => {}};
const hasFieldItem = dictHasField => dictHasField;
const eqItem = {eq: x => y => x.category === y.category && eq1(x.ids)(y.ids) && eq2(x.list)(y.list) && x.name === y.name && x.price === y.price && x.quantity === y.quantity};
const genericItem = {to: x => x, from: x => x};
const showItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {
        genericShowArgs: v => [
          "{ category: " + Data$dShow.showStringImpl(v.category) + ", ids: " + $0(v.ids) + (() => {
            if (v.list.tag === "Just") {
              return ", list: (Just " + Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show(v.list._1) + ")" + ", name: " + Data$dShow.showStringImpl(v.name) + ", price: " + Data$dMoney$dRounded.toString(v.price) + ", quantity: " + Data$dShow.showIntImpl(v.quantity) + " ";
            }
            if (v.list.tag === "Nothing") {
              return ", list: Nothing, name: " + Data$dShow.showStringImpl(v.name) + ", price: " + Data$dMoney$dRounded.toString(v.price) + ", quantity: " + Data$dShow.showIntImpl(v.quantity) + " ";
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(ItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(categoryIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(idsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)
    })(Unscramble.decodeRecordCons(listIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dAnalytics$dTypes$dItemList.unscrambleDecodeItemList))(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(priceIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(quantityIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(quantityIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(priceIsSymbol)({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))(nameIsSymbol)(encodeWithOptionsOther))(listIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dItemList.encodeItemList.encode(v2._1); }
        $runtime.fail();
      }
    }))(idsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => encode1};
    })()))(categoryIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(quantityIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())(priceIsSymbol)({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())(nameIsSymbol)(decodeWithOptionsOther)())(listIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dAnalytics$dTypes$dItemList.decodeItemList.decode)
  })())(idsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())(categoryIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  Item,
  ItemIsSymbol,
  categoryIsSymbol,
  decodeItem,
  decodeWithOptionsOther,
  encodeItem,
  encodeWithOptionsOther,
  eq1,
  eq2,
  eqItem,
  genericItem,
  hasFieldItem,
  idsIsSymbol,
  listIsSymbol,
  nameIsSymbol,
  newtypeItem_,
  priceIsSymbol,
  quantityIsSymbol,
  showItem,
  toFillFormTypeItem,
  unscrambleDecodeItem
};
